import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const testimonials = [
  {
    img: "testimonial-1.jpg",
    name: "Client One",
    profession: "Designer",
    message:
      "Great service! Quick support and very reliable.",
  },
  {
    img: "testimonial-2.jpg",
    name: "Client Two",
    profession: "Developer",
    message:
      "Excellent experience. I’d highly recommend this team.",
  },
  {
    img: "testimonial-3.jpg",
    name: "Client Three",
    profession: "Entrepreneur",
    message:
      "Fantastic results, delivered on time with great communication.",
  },
];

const ClientReview = ({data}) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1
        }
      }
    ]
  };

  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center mx-auto mb-5" style={{ maxWidth: 500 }}>
          <p className="text-primary text-uppercase mb-2">Client's Review</p>
          <h1 className="display-6 mb-0">More Than 500+ Customers Trusted Us</h1>
        </div>
        <Slider {...settings}>
          {testimonials.map((t, index) => (
            <div key={index} className="testimonial-item bg-white p-4 mx-2">
              <div className="d-flex align-items-center mb-4">
                <img
                  className="flex-shrink-0 rounded-circle border p-1"
                  src={`../assets/img/${t.img}`}
                  alt={t.name}
                  width={60}
                  height={60}
                />
                <div className="ms-3">
                  <h5 className="mb-1">{t.name}</h5>
                  <small>{t.profession}</small>
                </div>
              </div>
              <p className="mb-0">{t.message}</p>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default ClientReview;
